<template>
    <div class="container mx-auto px-4" v-if="Object.keys(user).length > 0">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ user.prefix }} {{ user.lastname }} {{ user.firstname }}</h1>

        <div class="mb-8 md:gap-8 md:grid md:grid-cols-2">
            <div class="flex flex-col md:items-center">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Belépési adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="email" required type="email"
                                v-bind:invalid="!!requestStore.errors?.email || (user.email.length > 0 && !validEmail)"
                                v-bind:label="__('E-mail cím')"
                                v-bind:placeholder="__('placeholders.email')"
                                v-model="user.email"
                                v-on:keyup="validateEmail"
                />
                <span class="px-1 text-error text-xs" v-if="user.email.length > 0 && !validEmail">
                    {{ __('Az email cím formátuma nem megfelelő.') }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password" placeholder="**********" type="password"
                                v-bind:invalid="!!requestStore.errors?.password || (password.length > 0 && password.length < 8)"
                                v-bind:label="__('Jelszó')"
                                v-model="password"
                />
                <span class="px-1 text-error text-xs" v-if="password.length > 0 && password.length < 8">
                    {{ __('A jelszó legalább :length karakterből kell álljon.', { 'length' : 8 }) }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password_confirmation" placeholder="**********" type="password"
                                v-bind:invalid="!!requestStore.errors?.password_confirmation || (password.length > 0 && password !== passwordConfirmation)"
                                v-bind:label="__('Jelszó újra')"
                                v-model="passwordConfirmation"
                />
                <span class="px-1 text-error text-xs" v-if="password.length > 0 && password !== passwordConfirmation">
                    {{ __('A jelszavak nem egyeznek.') }}
                </span>

                <c-control-select class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="role"
                                  v-bind:invalid="!!requestStore.errors?.role"
                                  v-bind:label="__('Szerepkör')"
                                  v-bind:options="roleOptions"
                                  v-model="user.role"
                                  v-on:update:model-value="resetResellerValues()"
                />
            </div>

            <div class="flex flex-col md:items-center md:mt-0 mt-8">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Személyes adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="prefix" type="text"
                                v-bind:invalid="!!requestStore.errors?.prefix"
                                v-bind:label="__('Előtag')"
                                v-bind:placeholder="__('placeholders.prefix')"
                                v-model="user.prefix"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="lastname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.lastname"
                                v-bind:label="__('Vezetéknév')"
                                v-bind:placeholder="__('placeholders.lastname')"
                                v-model="user.lastname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="firstname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.firstname"
                                v-bind:label="__('Keresztnév')"
                                v-bind:placeholder="__('placeholders.firstname')"
                                v-model="user.firstname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="phone" required type="text"
                                v-bind:invalid="!!requestStore.errors?.phone"
                                v-bind:label="__('Telefonszám')"
                                v-bind:placeholder="__('placeholders.phone')"
                                v-model="user.phone"
                />
            </div>
        </div>

        <div v-if="user.group?.is_webshop_enabled">
            <h2 class="font-semibold mb-8 uppercase">{{ __('Számlázási adatok') }}</h2>

            <div class="mb-8 md:gap-8 md:grid md:grid-cols-2">
                <div class="flex flex-col items-center">
                    <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="billing_name" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.billing_name"
                                    v-bind:label="__('Számlázási név')"
                                    v-model="user.billing_name"
                    />

                    <c-control-select class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="country" required
                                      v-bind:invalid="!!requestStore.errors?.country"
                                      v-bind:label="__('Ország')"
                                      v-bind:options="countries"
                                      v-model="user.country"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="city" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.city"
                                    v-bind:label="__('Település')"
                                    v-model="user.city"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="address_1" required rows="2" type="textarea"
                                    v-bind:invalid="!!requestStore.errors?.address_1"
                                    v-bind:label="__('Címsor 1')"
                                    v-model="user.address_1"
                    />
                </div>

                <div class="flex flex-col items-center">
                    <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="tax_id" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.tax_id"
                                    v-bind:label="__('Adószám')"
                                    v-model="user.tax_id"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="postcode" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.postcode"
                                    v-bind:label="__('Irányítószám')"
                                    v-model="user.postcode"
                                    v-on:update:model-value="updateCityAndCounty"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="county" required type="text"
                                    v-bind:invalid="!!requestStore.errors?.county"
                                    v-bind:label="__('Megye')"
                                    v-model="user.county"
                    />

                    <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="address_2" rows="2" type="textarea"
                                    v-bind:invalid="!!requestStore.errors?.address_2"
                                    v-bind:label="__('Címsor 2')"
                                    v-model="user.address_2"
                    />
                </div>
            </div>
        </div>

        <div>
            <h2 class="font-semibold mb-8 uppercase">{{ __('Egyéb adatok') }}</h2>

            <div class="md:gap-8 md:grid md:grid-cols-2">
                <c-control-autocomplete class="text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" label-field="name" name="group_id"
                                        v-bind:invalid="!!requestStore.errors?.group"
                                        v-bind:label="__('Felhasználói csoport')"
                                        v-bind:source-get="groupGet"
                                        v-bind:source-search="groupSearch"
                                        v-model="user.group"
                                        v-on:update:model-value="user.group_id = user.group?.id;"
                />

                <c-control-toggle class="md:mt-0 mt-8 text-center" class-field-wrapper="mx-auto" name="is_blacklisted"
                                  v-bind:invalid="!!requestStore.errors?.is_blacklisted"
                                  v-bind:label="__('Feketelistás?')"
                                  v-model="user.is_blacklisted"
                />

                <c-control-select class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="delivery_time"
                                  v-bind:options="deliveryTimeOptions"
                                  v-bind:label="__('Mikor kéri a kiszállítást?')"
                                  v-if="user.role === 'reseller'"
                                  v-model="user.delivery_time"
                />

                <c-control-select class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="shipping_zone"
                                  v-bind:options="shippingZoneOptions"
                                  v-bind:label="__('Kiszállítási zóna')"
                                  v-if="user.role === 'reseller'"
                                  v-model="user.shipping_zone"
                />


                <c-control-number class="mt-8 mx-auto text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="shipping_cost" placeholder="1000"
                                  v-bind:invalid="!!requestStore.errors?.shipping_cost"
                                  v-bind:label="__('Kiszállítási díj (bruttó)')"
                                  v-bind:min="1"
                                  v-if="user.role === 'reseller'"
                                  v-model="user.shipping_cost"
                />
            </div>
        </div>

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-bind:disabled="user.firstname.length === 0 || user.lastname.length === 0 || user.phone.length === 0 || !validEmail || (password.length > 0 && password.length < 8) || (password.length > 0 && password !== passwordConfirmation)"
                  v-on:click="submit"
        >
            {{ __('Mentés') }}
        </c-button>
    </div>
</template>

<script setup lang="ts">
    import { inject, isRef, onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import {
        CButton,
        CControlAutocomplete,
        CControlNumber,
        CControlSelect,
        CControlText,
        CControlToggle,
    } from '@teamfurther/cinderblock';
    import UserRepository from '../../repositories/UserRepository';
    import UserGroupRepository from '../../repositories/UserGroupRepository';
    import { useGeoStore } from '../../stores/geo';
    import { useRequestStore } from '../../stores/request';

    const __ = inject('__');
    const countries = ref([]);
    const deliveryTimeOptions = [
        { label: '-', value: null },
        { label: '07:00', value: '0700' },
        { label: '07:30', value: '0730' },
        { label: '08:00', value: '0800' },
        { label: '08:30', value: '0830' },
        { label: '09:00', value: '0900' },
        { label: '09:30', value: '0930' },
        { label: '10:00', value: '1000' },
        { label: '10:30', value: '1030' },
        { label: '11:00', value: '1100' },
        { label: '11:30', value: '1130' },
        { label: '12:00', value: '1200' },
        { label: '12:30', value: '1230' },
        { label: '13:00', value: '1300' },
        { label: '13:30', value: '1330' },
        { label: '14:00', value: '1400' },
        { label: '14:30', value: '1430' },
        { label: '15:00', value: '1500' },
        { label: '15:30', value: '1530' },
        { label: '16:00', value: '1600' },
    ];
    const geoStore = useGeoStore();
    const password = ref('');
    const passwordConfirmation = ref('');
    const roleOptions = [
        { label: 'Adminisztrátor', value: 'admin' },
        { label: 'Viszonteladó', value: 'reseller' },
        { label: 'Boltos', value: 'shop' },
        { label: 'Felhasználó', value: 'user' },
    ];
    const route = useRoute();
    const shippingZoneOptions = [
        { label: '-', value: null },
        { label: 'I. zóna', value: 'i' },
        { label: 'II. zóna', value: 'ii' },
        { label: 'III. zóna', value: 'iii' },
        { label: 'IV. zóna', value: 'iv' },
    ];
    const user = ref<object>({});
    const userId = route.params.user;
    const userRepository = new UserRepository();
    const userGroupRepository = new UserGroupRepository();
    const requestStore = useRequestStore();
    const validEmail = ref<boolean>(true);

    async function groupGet(group) {
        if (isRef(group) && group.value && group.value.id) {
            return await userGroupRepository.show(group.value.id);
        } else if (group && group.id) {
            return await userGroupRepository.show(group.id);
        } else {
            return null;
        }
    }

    async function groupSearch(val) {
        return await userGroupRepository.index({
            filters : {
                name: val
            }
        });
    }

    function resetResellerValues() {
        if (user.value.role === 'reseller') {
            return;
        }

        user.value.delivery_time = null;
        user.value.shipping_cost = null;
        user.value.shipping_zone = null;
    }

    async function submit() {
        user.value.password = password.value;
        user.value = await userRepository.update(userId, user.value);

        password.value = '';
        passwordConfirmation.value = '';
    }

    async function updateCityAndCounty() {
        if (!user.value.country || !user.value.postcode) {
            return;
        }

        user.value.city = await geoStore.findCityByPostcode(user.value.country, user.value.postcode);
        user.value.county = await geoStore.findCountyByPostcode(user.value.country, user.value.postcode);
    }

    function validateEmail() {
        validEmail.value = !!user.value.email.match(/\S+@\S+\.\S+/);
    }

    onMounted(async () => {
        countries.value = await geoStore.countries();
        countries.value.unshift({
            disabled: true,
            label: '---',
            value: null,
        });
        countries.value.unshift({
            label: __('country.HU'),
            value: 'HU',
        });

        user.value = await userRepository.show(userId, {
            include: ['group']
        });
    });
</script>
